const TITLE_FIELDS = {
  th: ["display_title_th", "title_th"],
  en: ["title_en_official", "title_en_translated"],
};

/** Resolve a stored title without changing its text or implying translation status. */
export function resolveDocumentTitle(document = {}, preferredLanguage = "th") {
  const preferred = preferredLanguage === "en" ? "en" : "th";
  const fallback = preferred === "en" ? "th" : "en";
  for (const language of [preferred, fallback]) {
    const text = TITLE_FIELDS[language]
      .map((field) => document?.[field])
      .find((value) => typeof value === "string" && value.trim());
    if (text) {
      return { text, language, isFallback: language !== preferred };
    }
  }
  return { text: "", language: preferred, isFallback: false };
}

/**
 * Pick at most one English line under the main title.
 *
 * An official English title of the parallel expression always wins. When
 * both candidates are machine drafts, the document-level draft is shown,
 * never both. A line that repeats the main title is omitted.
 */
export function chooseEnglishTitleLine({ document = {}, expressionLanguage, title, parallelDocument = null }) {
  const mainText = (title?.text || "").trim();
  const parallel = parallelDocument ? resolveDocumentTitle(parallelDocument, "en") : null;
  const parallelText = (parallel?.text || "").trim();
  const draft = (document?.title_en_translated || "").trim();
  const showDraft = expressionLanguage === "th" &&
    document?.title_en_translation_status === "machine_draft" && draft && draft !== mainText;
  const parallelOfficial = Boolean(parallelDocument?.title_en_official?.trim());

  if (parallelText && parallelText !== mainText && (parallelOfficial || !showDraft)) {
    return { kind: "parallel", ...parallel };
  }
  if (showDraft) {
    return { kind: "translation", text: draft, language: "en" };
  }
  return null;
}
